export default __webpack_public_path__ + "static/media/unicorn.76c7151b.svg";